module.exports = __webpack_public_path__ + "static/media/rahulSir.21bb3410.png";